import { useState } from 'react';
import { WbSelect, WbText } from '@workbench/react';
import { useTranslation } from 'react-i18next';

import _notification from '../../../Utils/Vimdt/notification';

/**
 * Select on top of `wb-select`; the native `<select>` is slotted so it stays
 * accessible and testable.
 */
function VimdtSelect({
	label,
	value,
	options,
	defaultValue,
	disabled,
	setValue,
	adjustableWith,
	backgroundSelectMessage = false,
	notify = true,
	className,
}) {
	const [key, setKey] = useState();
	const { t } = useTranslation();

	const openNotification = (selected) => {
		const background = backgroundSelectMessage
			? `${t(`vimdt.imagesTab.backgrounds.${selected}`)} (${selected})`
			: selected;

		setKey(
			_notification({
				title: label,
				message: `${t('vimdt.notification.switched')} ${background}`,
				duration: 5,
				key,
				onClose: () => setKey(undefined),
			})
		);
	};

	const onChange = (event) => {
		const selected = event.target.value;
		setValue(selected);
		if (notify) openNotification(selected);
	};

	return (
		<div className={className}>
			{/* wb-select ignores its slotted label while compact, so render it outside */}
			<WbText size="s">{label}</WbText>
			<WbSelect compact>
				<select
					aria-label={typeof label === 'string' ? label : undefined}
					value={value ?? defaultValue}
					disabled={disabled}
					onChange={onChange}
				>
					{options.map((opt) => (
						<option key={opt.id} value={opt.value}>
							{opt.name}
						</option>
					))}
				</select>
			</WbSelect>
		</div>
	);
}

export default VimdtSelect;
